/* global WebKitCSSMatrix */

const SwiperKiller = (root, sliderIndex, gap) => {
	const element = document.querySelector(`.${root}`);
	const swiperKiller = element.querySelector('.swiper-killer');
	const items = swiperKiller.querySelector('#slides');
	const prev = swiperKiller.querySelector('#prev');
	const next = swiperKiller.querySelector('#next');
	const dot = document.getElementById('slider-index');

	let posX1 = 0;
	let posX2 = 0;
	let posInitial;
	let posFinal;
	const threshold = 20;
	const slides = items.getElementsByClassName('slide');
	const slidesLength = slides.length;
	const slideSize = items.querySelectorAll('.slide')[0].offsetWidth;

	let index = sliderIndex;
	let allowShift = true;

	const dragStart = (e) => {
		e = e || window.event;
		e.preventDefault();
		posInitial = 0;

		if (e.type === 'touchstart') {
			posX1 = e.touches[0].clientX;
		} else {
			posX1 = e.clientX;
			document.onmouseup = dragEnd;
			document.onmousemove = dragAction;
		}
	};

	const getTranlateX = () => {
		const style = window.getComputedStyle(items);
		const matrix = new WebKitCSSMatrix(style.transform);
		return matrix.m41;
	};

	const dragAction = (e) => {
		e = e || window.event;

		if (e.type === 'touchmove') {
			posX2 = posX1 - e.touches[0].clientX;
			posX1 = e.touches[0].clientX;
		} else {
			posX2 = posX1 - e.clientX;
			posX1 = e.clientX;
		}

		items.style.transform = `translate(${getTranlateX() - posX2 + 'px'})`;
		if (index <= slidesLength && index !== 0) {
			dotDot(index);
		}
	};

	const dragEnd = (e) => {
		posFinal = getTranlateX();
		if (posFinal - posInitial < -threshold) {
			shiftSlide(1, 'drag');
		} else if (posFinal - posInitial > threshold) {
			shiftSlide(-1, 'drag');
		} else {
			items.style.transform = `translate(${posFinal + 'px'})`;
		}

		document.onmouseup = null;
		document.onmousemove = null;
	};

	const shiftSlide = (dir, action) => {
		items.classList.add('shifting');

		if (allowShift) {
			if (!action) {
				posInitial = items.offsetLeft;
			}

			if (dir === 1) {
				index++;
				items.style.transform = `translate(${
					-(slideSize + gap) + 'px'
				})`;
			} else if (dir === -1) {
				index--;
				items.style.transform = `translate(${slideSize + gap + 'px'})`;
			}

			checkIndex();

			if (dir === 1) {
				if (index !== slidesLength) {
					slides[index].style.order = 2;
				}
			}
		}

		allowShift = true;

		// incrémentation du dotdot
		if (index <= slidesLength && index !== 0) {
			dotDot(index);
		}
	};

	const dotDot = (index) => {
		dot.innerText = index;
	};

	const calculateSlidesLeft = () => {
		items.style.transform = `translate(${-(slideSize + gap) + 'px'})`;
	};

	function checkIndex() {
		if (index == 0) {
			index = slidesLength;
		}

		if (index == slidesLength + 1) {
			index = 1;
		}

		allowShift = true;
	}

	const changeOrder = () => {
		items.classList.remove('shifting');
		let prev;
		let current;
		let next;

		if (index == 1) {
			prev = slidesLength - 1;
			current = 0;
			next = index;
		} else if (index == slidesLength) {
			prev = index - 2;
			current = index - 1;
			next = 0;
		} else {
			prev = index - 2;
			current = index - 1;
			next = index;
		}

		for (let i = 0; i < slidesLength; i++) {
			if (i !== prev && i !== current && i !== next) {
				slides[i].style.order = 3;
			}

			slides[i].tabIndex = -1;
			slides[i].setAttribute('aria-hidden', true);
		}

		items.style.transform = `translate(0px)`;

		slides[prev].style.order = 0;
		slides[current].style.order = 1;
		slides[next].style.order = 2;

		unDisplayFocus(slides[prev]);
		unDisplayFocus(slides[next]);
		displayFocus(slides[current]);

		slides[current].setAttribute('aria-hidden', false);
	};

	const firstLoad = () => {
		dotDot(sliderIndex);
		calculateSlidesLeft();
		items.style.columnGap = gap + 'px';
		items.style.left = -(slideSize + gap) + 'px';
	};

	const unDisplayFocus = (elements) => {
		const focusableElements =
			'button, [href], [tabindex]:not([tabindex="-1"])';
		const skFocusable = elements.querySelectorAll(focusableElements);
		skFocusable.forEach((el) => {
			el.tabIndex = -1;
		});
	};

	const displayFocus = (slide) => {
		const focusableElements =
			'button, [href], [tabindex]:not([tabindex="-1"])';
		const slideFocusable =
			slide.querySelectorAll(focusableElements) || null;
		if (slideFocusable.length > 0) {
			slideFocusable.forEach((el) => {
				el.tabIndex = 0;
			});
		}
	};

	const init = () => {
		firstLoad();
		changeOrder(sliderIndex);

		// Mouse events
		items.onmousedown = dragStart;

		// Touch events
		items.addEventListener('touchstart', dragStart);
		items.addEventListener('touchend', dragEnd);
		items.addEventListener('touchmove', dragAction);

		// Click events
		prev.addEventListener('click', () => {
			shiftSlide(-1);
		});

		next.addEventListener('click', () => {
			shiftSlide(1);
		});

		items.addEventListener('transitionend', function (e) {
			if (e.propertyName !== 'order') {
				changeOrder();
			}
		});

		unDisplayFocus(items);
	};

	init();
};
